import { Database, FileSearch, Scale, Workflow } from "lucide-react";

const evidenceLayer = [
  { icon: Database, label: "Extraction and normalization" },
  { icon: Scale, label: "Deterministic rule checks" },
  { icon: FileSearch, label: "Evidence-linked findings" },
  { icon: Workflow, label: "Reports and audit records" },
];

export function OperatingModelSection() {
  return (
    <section className="relative overflow-hidden bg-[#EDF5F2] py-24">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(0,38,28,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(0,38,28,0.035)_1px,transparent_1px)] bg-[size:80px_80px]" />
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-3xl">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-[#315f50]">
              One platform
            </p>
            <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-[#00261C] sm:text-5xl">
              The technology stays the same. The delivery responsibility changes.
            </h2>
          </div>

          <div className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-[#00261C]/10 bg-[#00261C]/10 md:grid-cols-2">
            <article className="bg-[#EDF5F2] p-8 sm:p-10">
              <p className="font-mono text-xs uppercase tracking-[0.16em] text-[#315f50]">
                Self-serve software
              </p>
              <h3 className="mt-5 font-display text-2xl font-bold text-[#00261C]">
                Defined input. Bounded check. Reviewable output.
              </h3>
              <p className="mt-4 leading-relaxed text-[#00261C]/70">
                Your team uploads information, reviews the cited results, and downloads the
                report. Expert review is optional.
              </p>
            </article>
            <article className="bg-[#00261C] p-8 sm:p-10">
              <p className="font-mono text-xs uppercase tracking-[0.16em] text-[#B2F273]">
                Managed intelligence
              </p>
              <h3 className="mt-5 font-display text-2xl font-bold text-white">
                Messy evidence. Investigation. A delivered institutional outcome.
              </h3>
              <p className="mt-4 leading-relaxed text-[#EDF5F2]/60">
                Enso handles onboarding, exceptions, investigation, validation, and final
                delivery through the same platform.
              </p>
            </article>
          </div>

          <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {evidenceLayer.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-3 rounded-xl border border-[#00261C]/10 bg-white/35 p-4"
              >
                <Icon className="h-5 w-5 shrink-0 text-[#315f50]" />
                <span className="text-sm font-semibold text-[#00261C]">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
